import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './context/ThemeContext';
import { AdminProvider } from './context/AdminContext';
import { BandProvider } from './context/BandContext';
import { OfflineProvider } from './context/OfflineContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AxiosInterceptor from './components/AxiosInterceptor';
import AuthSync from './components/AuthSync';
import AudienceView from './pages/AudienceView';
import Dashboard from './pages/Dashboard';
import RequestsDashboard from './pages/RequestsDashboard';
import SongManagement from './pages/SongManagement';
import SongReview from './pages/SongReview';
import Analytics from './pages/Analytics';
import GigManagement from './pages/GigManagement';
import SetListBuilder from './pages/SetListBuilder';
import BrandingSettings from './pages/BrandingSettings';
import GigPrintSheet from './pages/GigPrintSheet';
import RequestSheet from './pages/RequestSheet';
import BandAbout from './pages/BandAbout';
import BandPublicPage from './pages/BandPublicPage';
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import EmailVerified from './pages/EmailVerified';
import NotFound from './pages/NotFound';
import MusicianLayout from './components/MusicianLayout';
import AdminLayout from './components/AdminLayout';
import Onboarding from './pages/Onboarding';
import JoinBand from './pages/JoinBand';
import RemovedFromBand from './pages/RemovedFromBand';
import Admin from './pages/Admin';
import Help from './pages/Help';
import HelpArticle from './pages/HelpArticle';

function App() {
  return (
    <AdminProvider>
    <BandProvider>
    <OfflineProvider>
    <ThemeProvider>
    <Router>
      <AxiosInterceptor />
      <AuthSync />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#333',
            color: '#fff',
            padding: '16px',
            borderRadius: '8px',
          },
          success: {
            iconTheme: {
              primary: '#28a745',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#dc3545',
              secondary: '#fff',
            },
          },
        }}
      />
      <Routes>
        {/* Public routes */}
        <Route path="/band/:bandSlug" element={<BandPublicPage />} />
        <Route path="/gig/:bandSlug/about" element={<BandAbout />} />
        <Route path="/gig/:bandSlug" element={<AudienceView />} />
        <Route path="/" element={<Home />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/email-verified" element={<EmailVerified />} />
        <Route path="/join" element={<JoinBand />} />
        <Route path="/removed" element={<RemovedFromBand />} />

        {/* Onboarding */}
        <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />

        {/* Admin */}
        <Route path="/admin" element={<AdminRoute><AdminLayout><Admin /></AdminLayout></AdminRoute>} />

        {/* Protected routes */}
        <Route path="/dashboard" element={<ProtectedRoute><MusicianLayout title="Home"><Dashboard /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/requests" element={<ProtectedRoute><MusicianLayout title="Live Requests" scrollable={false}><RequestsDashboard /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/songs" element={<ProtectedRoute><MusicianLayout title="Songs" scrollable={false}><SongManagement /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/songs/review" element={<ProtectedRoute><MusicianLayout title="Review songs" scrollable={false}><SongReview /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/analytics" element={<ProtectedRoute><MusicianLayout title="Analytics"><Analytics /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/gigs" element={<ProtectedRoute><MusicianLayout title="Gigs"><GigManagement /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/gigs/:gigId/setlist" element={<ProtectedRoute><MusicianLayout scrollable={false}><SetListBuilder /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/branding" element={<ProtectedRoute><MusicianLayout title="Branding & Settings"><BrandingSettings /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/help" element={<ProtectedRoute><MusicianLayout title="Help & Guides"><Help /></MusicianLayout></ProtectedRoute>} />
        <Route path="/dashboard/help/:slug" element={<ProtectedRoute><MusicianLayout title="Help & Guides"><HelpArticle /></MusicianLayout></ProtectedRoute>} />
        <Route path="/print/gig/:gigUrl" element={<ProtectedRoute><GigPrintSheet /></ProtectedRoute>} />
        <Route path="/print/gig/:gigUrl/request-sheet" element={<ProtectedRoute><RequestSheet /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
    </ThemeProvider>
    </OfflineProvider>
    </BandProvider>
    </AdminProvider>
  );
}

export default App;
